// extracted by mini-css-extract-plugin
export default {"errorNotFountWrapper":"Page404_errorNotFountWrapper__kaVJ1","errorNotFount":"Page404_errorNotFount__An4d+"};